var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNoMessageIcon = function SvgNoMessageIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 147,
    viewBox: "0 0 142 147",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.695 80.1834H0.353516L18.4049 67.5371H123.644L141.695 80.1834Z",
    fill: "url(#paint0_linear_4294_6008)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142 80H0L17.5632 147H122.568L142 80Z",
    fill: "url(#paint1_linear_4294_6008)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4294_6008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8355 8.95898H40.514C39.0278 8.95898 37.823 10.1638 37.823 11.65V53.8226C37.823 55.3088 39.0278 56.5136 40.514 56.5136H98.8355C100.322 56.5136 101.527 55.3088 101.527 53.8226V11.65C101.527 10.1638 100.322 8.95898 98.8355 8.95898Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8356 8.95898H71.7763H68.9625C68.9625 8.95898 92.7392 10.5614 94.6151 10.5614C95.5394 10.5614 96.8661 11.4993 96.7254 13V19.5C96.7254 20.9862 97.2881 28 97.2881 31.5645L98.8356 56.5136C100.322 56.5136 101.527 55.3088 101.527 53.8226V11.65C101.527 10.1638 100.322 8.95898 98.8356 8.95898Z",
    fill: "#F7B53C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5139 56.5137L85.0948 56.5137C86.581 56.5137 92.9734 56.5137 91.6603 56.5137C91.6603 56.5137 63.5753 53.7317 56.9568 49.7605C53.7678 47.8472 49.8285 45.2584 48.1402 42.6322C46.4519 40.006 44.7907 36.5945 44.0133 34.0032C42.8877 30.2515 41.9498 28.5632 41.5746 22.748C41.1995 16.9328 39.5002 10.5 39.5002 10.5C38.014 10.5 37.8229 10.1639 37.8229 11.6501L37.8229 53.8226C37.8229 55.3089 39.0277 56.5137 40.5139 56.5137Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 19.0003L37.5001 10.5003L74.0001 37L69.4039 41.5962C68.8831 42.117 68.0612 42.1826 67.4644 41.7511L36.0001 19.0003Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.263 12.2038C100.606 11.8771 100.492 11.3048 100.05 11.134C99.8371 11.0517 99.5964 11.088 99.4172 11.2295L67.8683 36.1323C67.3521 36.5398 67.1615 37.236 67.3983 37.8496L68.1916 39.9058C68.5765 40.9035 69.8519 41.1895 70.6259 40.4517L100.263 12.2038Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1774 12.2848C37.5271 11.7716 37.4161 10.8283 37.9294 10.1781L38.2392 9.7856C38.5813 9.35209 39.2102 9.27806 39.6437 9.62025L70.3876 33.8877C71.0379 34.4009 71.1489 35.3442 70.6357 35.9944C70.1224 36.6447 69.1792 36.7557 68.5289 36.2425L38.1774 12.2848Z",
    fill: "#C15F0E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 41.4225,
    rx: 1.5,
    transform: "matrix(-0.619579 -0.784934 -0.784934 0.619579 101.981 11.3555)",
    fill: "#C15F0E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M105.354 14.4549C107.997 11.7939 107.997 7.47954 105.354 4.81853C102.712 2.15753 98.4272 2.15753 95.7847 4.81854C93.1422 7.47955 93.1422 11.7939 95.7847 14.4549C98.4272 17.1159 102.712 17.1159 105.354 14.4549Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.363 13.4113C104.559 12.5009 105.606 9.97037 104.702 7.75927C103.797 5.54817 101.284 4.49378 99.0888 5.40422C96.893 6.31467 95.846 8.84519 96.7501 11.0563C97.6542 13.2674 100.167 14.3218 102.363 13.4113Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M100.679 6.29327C100.482 7.67741 100.679 9.40487 98.2021 9.62081C98.9356 9.9609 99.7549 10.2578 100.267 10.9402C100.721 11.548 101.091 12.5705 101.169 13.3154C101.308 12.5122 101.12 11.7629 101.619 10.9402C101.8 10.6368 102.048 10.3783 102.345 10.1841C102.641 9.98995 102.978 9.86527 103.33 9.81947C102.538 9.3876 101.849 9.45238 101.368 8.51199C101.181 8.1567 101.025 7.78567 100.902 7.40317C100.785 7.01773 100.826 6.41851 100.576 6.13672L100.679 6.29327Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.3495 45.4235C43.376 43.3828 43.376 40.0742 41.3495 38.0335C39.323 35.9928 36.0374 35.9928 34.0109 38.0335C31.9844 40.0742 31.9844 43.3828 34.0109 45.4235C36.0374 47.4642 39.323 47.4642 41.3495 45.4235Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.5743 45.0908C41.5305 44.2797 42.4634 42.0252 41.6579 40.0553C40.8524 38.0853 38.6136 37.1459 36.6573 37.9571C34.7011 38.7682 33.7682 41.0227 34.5737 42.9927C35.3792 44.9626 37.6181 45.902 39.5743 45.0908Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.0734 38.7508C37.8982 39.984 38.0734 41.523 35.8672 41.7154C36.5206 42.0184 37.2506 42.2829 37.7065 42.8908C38.1112 43.4324 38.4413 44.3433 38.51 45.007C38.634 44.2914 38.4665 43.6238 38.9118 42.8908C39.073 42.6206 39.294 42.3902 39.5579 42.2173C39.8219 42.0443 40.122 41.9332 40.4355 41.8924C39.7298 41.5076 39.1161 41.5653 38.6882 40.7275C38.5208 40.411 38.3818 40.0804 38.2729 39.7396C38.1683 39.3962 38.2051 38.8624 37.9824 38.6113L38.0734 38.7508Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4294_6008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 67,
    width: 71,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0608,
    y: 67.5371,
    width: 70.6707,
    height: 12.6463,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4294_6008)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4294_6008)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.0239,
    cy: 67.9098,
    rx: 24.5488,
    ry: 4.09146,
    fill: "#160438"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4294_6008",
    x: 24.4751,
    y: 43.8184,
    width: 89.0977,
    height: 48.1836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_4294_6008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4294_6008",
    x1: 355820,
    y1: 26953.5,
    x2: 355816,
    y2: 31400.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4294_6008",
    x1: 40.9175,
    y1: 77.8712,
    x2: 43.7311,
    y2: 129.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272054",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4294_6008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1452,
    height: 52.1492,
    fill: "white",
    transform: "translate(37.823 4.36523)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoMessageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-message-icon.09e8a81a.svg";
export { ForwardRef as ReactComponent };